import React from 'react';
import PropTypes from 'prop-types';
import SingleBadge from '../SingleBadge/SingleBadge';

const MultiBadge = (props) => {
    const { className, badges } = props;

    return badges ? badges.map((badge) => <SingleBadge className={className} key={badge.key} badge={badge} />) : null;
};

MultiBadge.propTypes = {
    className: PropTypes.string,
    badges: PropTypes.array,
};

export default MultiBadge;
